import { Meteor } from 'meteor/meteor';
import { ensureIosDevice } from '/imports/api/users';
import { IosDevice } from '/imports/types';

const w = window as any;
let _isIos = false;

if (Meteor.isClient) {
  /**
   * Registers an iOS device and marks the client as iOS (exposed on window).
   * @param device - the iOS device descriptor
   */
  w.ensureIosDevice = async (device: IosDevice) => {
    _isIos = true;
    try {
      await ensureIosDevice.call(device);
    }
    catch (error) {
      console.log(error);
    }
  };
}

/** Whether the client is running as an iOS device. */
export const isIos = () => _isIos;